import themeUtils from '../themeUtils';

export default class DynamicCollectionsList {
  constructor(section) {
    this.el = section.el;
    this.initializedClass = 'collection-initialized';
    this.collectionsContainer = this.el.querySelector('[data-collections]');
    this.collectionHeight = this.el.querySelector('.home-collections').getBoundingClientRect().height;
    this._setupCollections = this._setupCollections.bind(this);
    this._bindEvents();
    this._setupCollections();
  }

  onSectionLoad() {
    this._bindEvents();
    this._setupCollections();
  }

  onSectionUnload() {
    this._unbindEvents();
  }

  onSectionBlockSelect(event) {
    this._setupCollections();
  }

  onSectionBlockDeselect(event) {
    this._setupCollections();
  }

  _bindEvents() {
    document
      .querySelectorAll('.home-collection-overlay-wrapper')
      .forEach(homeCollectionOverlayWrapper => homeCollectionOverlayWrapper.addEventListener('click', e => this._redirectCollection(e)));
    this.el.addEventListener('rimg:load', () => {
      this._setupCollections();
    });
    window.addEventListener('resize', themeUtils.debounce(this._setupCollections, 500));
  }

  _unbindEvents() {
    document
      .querySelectorAll('.home-collection-overlay-wrapper')
      .forEach(homeCollectionOverlayWrapper => homeCollectionOverlayWrapper.removeEventListener('click', e => this._redirectCollection(e)));
    this.el.removeEventListener('rimg:load', () => this._setupCollections());
    window.removeEventListener('resize', themeUtils.debounce(this._setupCollections, 500));
  }

  _setupCollections() {
    const featuredCollectionImages = this.el.querySelectorAll('.home-collection-image img, .home-collection-image svg');

    featuredCollectionImages.forEach(collectionImage => {
      const collectionImageHeight = collectionImage.getBoundingClientRect().height;

      collectionImage.style.height = 'auto';

      if (collectionImageHeight > 0) {
        this.collectionHeight = collectionImage.getBoundingClientRect().height;
      }
    });

    featuredCollectionImages.forEach(collectionImage => {
      collectionImage.style.height = '';
    });
    this.el.querySelectorAll('.home-collection-image').forEach(homeCollectionImageEl => {
      homeCollectionImageEl.style.height = `${this.collectionHeight}px`;
    });
  }

  _redirectCollection(e) {
    const { currentTarget } = e;

    if (!this.collectionsContainer.contains(currentTarget)) return;

    const { url } = currentTarget.dataset;

    if (url !== '') {
      window.location = url;
    }
  }
}
